//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Container } from "./styles";
import { Column, TitleSection } from "components/styles";
//#endregion
//#region Components
import DialogAlert from "components/DialogAlert/DialogAlert";
import CloseButton from "components/CloseButton/CloseButton";
import Fields from "./components/Fields/Fields";
import Footer from "./components/Footer/Footer";
import ChangeHistory from "./components/ChangeHistory/ChangeHistory";
//#endregion
//#region Images
//#endregion
//#region Services
//#endregion
//#region Utils
import { INIT_ERRORS_FORM, INIT_FORM } from "./utils/constants";
//#endregion

const FormRole = ({
    show,
    toggleShow,
    currentUser,
    closeForm,
    loadingRequest,
    data: {
        categoryList,
        roleList,
        campusList
    },
    userList
}) => {
    const isCreate = !Boolean(currentUser);
    //#region States
    const [form, setForm] = useState({ ...INIT_FORM });
    const [errors, setErrors] = useState({ ...INIT_ERRORS_FORM });
    const [errorText, setErrorText] = useState(null);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!isCreate) {
            setForm({ ...currentUser });
            return;
        }
        setForm({ ...INIT_FORM });
    }, [currentUser]);
    useEffect(() => {
        if (show) return;
        clearForm();
    }, [show]);
    //#endregion
    //#region Functions
    const changeField = (field, value) => {
        setForm(prev => ({
            ...prev,
            [field]: value
        }));
        setErrors(prev => ({
            ...prev,
            [field]: false
        }));
    }
    const changeCategoryField = (id, name) => {
        changeField("category", { id, name });
        changeField("role", { id: 0, name: "" });
    };
    const changeRoleField = (id, name) => {
        changeField("role", { id, name });
    }
    const clearForm = () => {
        setForm({ ...INIT_FORM });
        setErrors({ ...INIT_ERRORS_FORM });
        setErrorText(null);
    }
    const isThereError = () => {
        return Object.values(errors).some(error => error) && errorText;
    }
    //#endregion
    return (
        <>
        <DialogAlert 
            show={show}
            toggleShow={toggleShow}>
            <CloseButton onClick={() => toggleShow()}/>
            <Container>
                <TitleSection textAlign="center">
                    {isCreate 
                    ? "Asignar Nuevo Rol" 
                    : "Editar Rol"}</TitleSection>
                <Fields 
                    isCreate={isCreate}
                    data={{
                        categoryList,
                        roleList
                    }}
                    formData={{
                        currentUser,
                        form, 
                        errors,
                        errorText,
                        isThereError
                    }}
                    changeForm={{
                        changeField,
                        changeCategoryField,
                        changeRoleField
                    }}/>
                <Column marginTop={isCreate ? "25px" : "8px"} gap="20px">
                    {!isCreate && 
                    <ChangeHistory user={currentUser.user}/>}
                    <Footer 
                        currentUser={currentUser}
                        formData={{
                            form: {
                                value: form,
                                set: setForm,
                                changeField
                            }, 
                            errors: {
                                value: errors,
                                set: setErrors
                            },
                            errorText: {
                                value: errorText,
                                set: setErrorText
                            }
                        }}
                        isCreate={isCreate}
                        loadingRequest={loadingRequest}
                        closeForm={closeForm}
                        data={{
                            campusList
                        }}
                        userList={userList}/>
                </Column>
            </Container>
        </DialogAlert>
        </>
    );
}

export default FormRole;